<template>
    <el-dialog title="Your Xml File" :visible="visible" @update:visible="$emit('update:visible', $event)">
        <h1 v-if="isSuccessful" class="successIcon">✔</h1>
        <img v-if="hasError" class="errorIcon" src="../../../assets/error.png" />
        <img v-if="isLoading" class="loadingIcon"
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif" />
        <textarea cols="75" rows="15" id="txtName" @keyup.enter="sendXml" v-model="xmlData" type="text" />
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" :disabled="loading" :loading="loading" @click="sendXml">
                Send Xml File
            </el-button>
        </span>
    </el-dialog>
</template>
<script>

import axios from "axios";
import { URL, getUrl } from "@api/constants";
export default {
    props: ['visible', 'device', 'serial', 'xmlData', 'isLoading', 'isSuccessful', 'hasError'],
    data() {
        return {
            loading: false,
        }
    },

    methods: {
        sendXml() {
            this.hasError = false;
            this.isLoading = true;
            const token = localStorage.getItem("jwt_access_token");
            const data = {
                "configuration": `${this.xmlData}`,
                "deviceSerial": this.serial
            }
            axios.post(getUrl(URL.POST_XML_FILE), data, {
                headers: {
                    'Authorization': `Basic ${token}`,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(res => {
                if (res.data.success === true) {
                    this.isLoading = false;
                    this.isSuccessful = true;
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                }
            })
                // .then(res => res.data.success === true ? this.isSuccessful = true : null)
                //     .then(res => res.data.success === true ? setTimeout(() => {
                //         window.location.reload()
                //     }, 2000) : null)
                .catch(err => {
                    this.isLoading = false;
                    this.hasError = true
                })
        },
    },
}
</script>
<style lang="scss">
.successIcon {
    color: green;
    text-align: center;
    font-size: 100px;
    padding: 0;
    margin: 0;
}

.errorIcon {
    width: 480px;
    height: 319px;
    frameBorder: "0";
    position: absolute;
    top: 20%;
    left: 8%;
}

.loadingIcon {
    position: absolute;
    top: 50%;
    left: 40%;
    transform: translate(-50%, -50%);

}
</style>



// WEBPACK FOOTER //
// XmlDialog.vue?4ffa8901